import { Breakpoint } from '../propsValues/breakpoint';

import { useMedia } from './useMedia';

export function useScreenSize(size: Breakpoint) {
  return useMedia(`(min-width: ${size}px)`);
}
